
















import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

import { Meta } from '@/decorators';
import store from '@/store';

import IService from '@/store/modules/services/types/IService';

import BackgroundImage from '@/components/ui/BackgroundImage.vue';
import Service from '@/components/blocks/services/Service.vue';
import IServiceMeta from '@/store/modules/services/types/IServiceMeta';
import IServiceHeader from '@/store/modules/services/types/IServieHeader';

async function dataHook(to: Route, from: Route, next: (callback?: any) => void) {
  try {
    await store.dispatch('services/load');
    next(true);
  } catch (error) {
    store.commit('app/error', error, { root: true });
    next({ path: '/error' });
  }
}

@Component({
  components: {
    BackgroundImage,
    Service,
  },
})
export default class Services extends Vue {
  private get meta(): IServiceMeta {
    return this.$store.state.services.meta;
  }

  private get header(): IServiceHeader {
    return this.$store.state.services.header;
  }

  private get services(): IService[] {
    return this.$store.state.services.services;
  }

  @Meta
  public metaInfo() {
    return {
      title: this.meta.title,
       meta: [{
        vmid: 'description',
        name: 'description',
        content: this.meta.description,
      }],
    };
  }

  private mounted(): void {
    this.$nextTick(() => {
      this.$bus.$emit('progress-stop');
    });
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (callback?: any) => void) {
    await dataHook(to, from, next);
  }
}
